import { BROADCAST_NOTIFY_DIRECTOR_ATTENDEE_LEAVING } from '../Types';
import { withCurrentParams } from '../utils';

function notifyDirectorAttendeeLeaving(state, joinModal = false) {
  return withCurrentParams((dispatch, { broadcastId }, getState, socket) => {
    const { meeting, isPresenterDismissed = false } = getState();
    const attendeeId =
      meeting && meeting?.attendeeResponse?.Attendee?.AttendeeId;
    const action = {
      type: BROADCAST_NOTIFY_DIRECTOR_ATTENDEE_LEAVING,
      payload: {
        closedOrReloadTab: state?.closedOrReloadTab
      }
    };

    if (attendeeId && joinModal) {
      const presence = {
        attendeeId,
        broadcastId,
        isPresenterDismissed
      };
      socket.emit('attendeeLeaving', presence);
    }
    dispatch(action);
  });
}

export default notifyDirectorAttendeeLeaving;
